'use strict';

exports.__esModule = true;
var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];


//////////////////
// WEBPACK FOOTER
// ../~/_redux-devtools-dock-monitor@1.1.3@redux-devtools-dock-monitor/lib/constants.js
// module id = 708
// module chunks = 0